import * as React from "react";
import { toast, Loader, QuantitySelector } from "@grandvisionhq/common";
import { isNil } from "@grandvisionhq/utils";
import { useAddToCart } from "../../../../../../hooks/hooks/use-add-to-cart.js";
import { useSanitization } from "../../../../../../hooks/hooks/use-sanitization.js";
import { AddToCart } from "../../../../components/modules/AddToCart/components/AddToCart.js";
import { ConfirmationModalContainer } from "./ConfirmationModalContainer.js";
/* empty css                                                                  */
import { useCart } from "../../../../../../context/Cart/context/Cart/context.js";
const AddToCartContainer = ({
  lineItemDrafts,
  isQuantityDiscountSelected,
  onSuccess,
  isQuantitySelectorEnabled,
  handleQuantityUpdate,
  productType,
  quantity = 1,
  ...buttonProps
}) => {
  const [addToCart, { loading }] = useAddToCart();
  const { cart } = useCart();
  const [
    { isModalOpen, sanitizationPayloads, validation },
    { onSolvableValidationError, pushRemoveLineItemDataLayerEvent, reset }
  ] = useSanitization();
  const onValidationError = React.useCallback((validationCodes) => {
    validationCodes.forEach((code) => toast.failed(`cart.${code}`));
  }, []);
  const onError = React.useCallback((errorCode) => {
    toast.failed(`cart.${errorCode}`);
  }, []);
  const handleSuccess = React.useCallback(
    (addedLineItems) => {
      onSuccess?.(addedLineItems);
      reset();
    },
    [onSuccess, reset]
  );
  const handleOnClick = React.useCallback(() => {
    addToCart(
      lineItemDrafts,
      handleSuccess,
      onValidationError,
      onError,
      onSolvableValidationError,
      sanitizationPayloads,
      pushRemoveLineItemDataLayerEvent,
      isQuantityDiscountSelected
    );
  }, [
    addToCart,
    lineItemDrafts,
    handleSuccess,
    onValidationError,
    onError,
    onSolvableValidationError,
    sanitizationPayloads,
    pushRemoveLineItemDataLayerEvent,
    isQuantityDiscountSelected
  ]);
  const handleDecreaseQuantity = React.useCallback(() => {
    handleQuantityUpdate && handleQuantityUpdate(quantity - 1);
  }, [handleQuantityUpdate, quantity]);
  const handleIncreaseQuantity = React.useCallback(() => {
    handleQuantityUpdate && handleQuantityUpdate(quantity + 1);
  }, [handleQuantityUpdate, quantity]);
  if (!lineItemDrafts.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !isNil(validation) && /* @__PURE__ */ React.createElement(
    ConfirmationModalContainer,
    {
      lineItems: cart?.lineItems,
      handleOnAction: handleOnClick,
      handleOnCancel: reset,
      isLoading: loading,
      isOpen: isModalOpen,
      onModalClose: reset,
      validation
    }
  ), buttonProps.variant === "ghost" ? loading ? /* @__PURE__ */ React.createElement(Loader, { className: "add-to-cart-container__loader" }) : /* @__PURE__ */ React.createElement("div", { className: "add-to-cart-container" }, isQuantitySelectorEnabled && quantity && /* @__PURE__ */ React.createElement(
    QuantitySelector,
    {
      onDecreaseQuantity: handleDecreaseQuantity,
      onIncreaseQuantity: handleIncreaseQuantity,
      minimumQuantity: 1,
      maximumQuantity: productType === "Solutions" ? 5 : 10,
      quantity,
      "data-t": "quantity-selector"
    }
  ), /* @__PURE__ */ React.createElement(
    AddToCart,
    {
      onClick: handleOnClick,
      disabled: loading || buttonProps.disabled,
      ...buttonProps
    }
  )) : /* @__PURE__ */ React.createElement(
    AddToCart,
    {
      onClick: handleOnClick,
      disabled: loading || buttonProps.disabled,
      ...buttonProps
    }
  ));
};
export {
  AddToCartContainer
};
//# sourceMappingURL=AddToCartContainer.js.map
